<script setup>
import { computed } from 'vue';
import UserAvatarWithName from 'dashboard/components/widgets/UserAvatarWithName.vue';
import CardLabels from 'dashboard/components/widgets/conversation/conversationCardComponents/CardLabels.vue';
import SLAViewDetails from './SLAViewDetails.vue';
const props = defineProps({
  slaName: {
    type: String,
    required: true,
  },
  conversationId: {
    type: Number,
    required: true,
  },
  conversation: {
    type: Object,
    required: true,
  },
  slaEvents: {
    type: Array,
    default: () => [],
  },
});

const conversationLabels = computed(() => {
  return props.conversation.labels
    ? props.conversation.labels.split(',').map(item => item.trim())
    : [];
});

const routerParams = computed(() => ({
  name: 'inbox_conversation',
  params: { conversation_id: props.conversationId },
}));
</script>

<template>
  <div
    data-testid="sla-report-item"
    class="flex flex-col w-full gap-3 py-4 border-b last:border-b-0 border-n-weak md:grid md:items-center md:min-h-16 md:grid-cols-12 md:gap-4 md:px-6"
  >
    <div
      class="flex flex-wrap min-w-0 items-center gap-2 md:col-span-6 px-0 py-2 text-sm tracking-[0.5] text-n-slate-12 rtl:text-right"
    >
      <router-link :to="routerParams" class="text-n-slate-12 hover:underline">
        {{ `#${conversationId}` }}
      </router-link>
      <span class="text-n-slate-11">
        {{ $t('SLA_REPORTS.WITH') }}
      </span>
      <span class="min-w-0 break-words text-n-slate-12">{{
        conversation.contact.name
      }}</span>
      <CardLabels
        v-if="conversationLabels.length"
        class="w-full md:w-[60%]"
        :conversation-id="conversationId"
        :conversation-labels="conversationLabels"
      />
    </div>
    <div
      class="flex flex-col min-w-0 gap-1 py-2 text-sm text-n-slate-12 md:col-span-2"
    >
      <span class="text-xs text-n-slate-11 md:hidden">{{ $t('SLA_REPORTS.TABLE.HEADER.POLICY') }}</span>
      <span class="break-words">{{ slaName }}</span>
    </div>
    <div class="flex flex-col items-start min-w-0 md:col-span-2 gap-2">
      <span class="text-xs text-n-slate-11 md:hidden">{{ $t('SLA_REPORTS.TABLE.HEADER.AGENT') }}</span>
      <UserAvatarWithName
        v-if="conversation.assignee"
        :user="conversation.assignee"
      />
      <span v-else class="text-n-slate-11">{{ $t('SLA_REPORTS.UNASSIGNED') }}</span>
    </div>
    <SLAViewDetails :sla-events="slaEvents" />
  </div>
</template>
